import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { env } from "./env";

/**
 * Cliente Supabase do browser — única instância (singleton) por aba.
 *
 * Diferença-chave vs o legado Next: lá a sessão vivia em cookies via
 * `@supabase/ssr` (pra SSR validar server-side). Aqui é SPA puro, então a
 * sessão fica em `localStorage` (persistSession) e o token vai no header
 * `Authorization: Bearer` em cada chamada ao Worker. O Worker valida o JWT
 * (HS256 local) — não depende de cookie.
 */
let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  if (!client) {
    client = createClient(env.supabaseUrl, env.supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: "kyra-portal-auth",
      },
    });
  }
  return client;
}
